'use strict';

/* globals dataLayer */

const Analytics = require('./analytics');

var checkoutStages = [
    'cart',
    'shipping',
    'payment',
    'placeOrder',
    'submitted'
];
var paymentMap = {
    'CREDIT_CARD': 'Credit Card',
    'CREDIT_CARD_AMEX': 'American Express',
    'IYZICO_CREDIT_CARD': 'yzico',
    'BML': 'Bill me Later',
    'MYBANK': 'My Bank',
    'PayPal': 'PayPal',
    'S2PALI': 'Alipay',
    'S2PIDE': 'iDeal',
    'IDEAL': 'iDeal',
    'S2PKLA': 'Klarna',
    'KLARNA': 'Klarna',
    'GIFT_CARD': 'Giftcard',
    'S2PSOF': 'Sofort',
    'SOFORT': 'Sofort',
    'S2PMUL': 'Multibanco',
    'CONTRASSEGNO': 'cash_on_delivery',
    'APALIPAY': 'Alipay',
    'APCREDITCARD': 'Credit Card',
    'APUNIONPAY': 'Union Pay',
    'S2PUNI': 'Union Pay',
    'APWECHAT': 'We Chat',
    'PRZELEWY24': 'Przelewy24',
    'PAYPO': 'PayPo',
    'BLIK': 'Blik',
    'S2PCRU': 'Cards_Russia',
    'WECHAT': 'wechat',
    'MULTIBANCO': 'Multibanco',
    'DW_APPLE_PAY': 'ApplePay',
    'ScalaPay': 'ScalaPay',
    'MBWAY': 'MB Way',
    'AFTERPAY_PBI': 'Afterpay',
    'PORTMONE': 'Portmone',
    'PAYBYLINK': 'pay_with_link',
    'GOOGLEPAY': 'google_pay',
    'AMAZONPAY': 'amazon_pay',
    'PAYGINE': 'paygine',
    'BIZUM': 'bizum'
};

const stageEventMap = {
    2: 'view_cart',
    3: 'add_shipping_info',
    4: 'add_payment_info'
};

function getCurrentStage () {
    let container = $('#checkout-main');
    let confirmContainer = $('.analytics.checkout.stage.confirm');
    if (confirmContainer.length > 0) {
        return 6;
    }
    if (container.length === 0) {
        return 2;
    }
    return checkoutStages.indexOf(container.data('checkout-stage')) + 1;
}

function getPaymentMethod (rawMethod) {
    let mapped = paymentMap[rawMethod];
    if (mapped) {
        return mapped;
    }
    return 'other';
}

function isCheckoutFunnel () {
    let link = window.location.href.toLowerCase();
    return (link.indexOf('cart') !== -1) || (link.indexOf('checkout') !== -1) || (link.indexOf('confirm') !== -1);
}

function isCart () {
    return window.location.href.toLowerCase().indexOf('cart') !== -1;
}

function isShipping () {
    if ($('.data-checkout-stage').attr('data-checkout-stage') && $('.data-checkout-stage').attr('data-checkout-stage').length > 0) {
        return $('.data-checkout-stage').attr('data-checkout-stage') === 'shipping';
    } else {
        return false;
    }
}

function isPayment () {
    return window.location.href.toLowerCase().indexOf('payment') !== -1;
}

function isGift () {
    return window.location.href.toLowerCase().indexOf('gift') !== -1;
}

function pushChangeStep (step) {
    if (dataLayer && dataLayer[0]) {
        var wSetupEvent = dataLayer[0];
        wSetupEvent.pageTemplate = (step === 'funnel_step4' ? 'funnel_step3' : step);
        dataLayer.push(wSetupEvent);
    }
}
class CheckoutFunnel extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'CheckoutFunnel';

        if (isCheckoutFunnel()) {
            super.init(globalContainer, helperContainer);
            this.pushLandingInteraction();
            this.prepareObservers();
            this.prepareCartInteractionObservers();
        }
    }

    getDisountsList () {
        let discounts = $('.analytics-checkout-discount-applied');
        let types = '';

        for (let i = 0; i < discounts.length; i++) {
            types = types === '' ? discounts.eq(i).data('promo-type') : types + '-' + discounts.eq(i).data('promo-type');
        }
        return types.toLowerCase();
    }

    pushFinalStage (stage) {
        let link = window.location.href.toLowerCase();
        if (stage !== 6) {
            return;
        }
        if (link.indexOf('confirmation') === -1) {
            return;
        }
        let container = $('.analytics.checkout.stage.confirm');
        let giftkitCard = $('.analytics-gift-kit-product').eq(0);
        let giftkitCardQuantity = $('.analytics-gift-kit-product').length;
        let giftkitTotal = giftkitCardQuantity > 0 ? (parseFloat(giftkitCardQuantity) * parseFloat(giftkitCard.data('analytics-price'))) : '0.00';
        let products = this.helper.getProductList();
        let extrascost =
            (container.data('costGiftPack') !== 0 ? 'cost_of_gift_wrapping' : '')
            + (giftkitTotal !== '0.00' ? (container.data('costGiftPack') !== 0 ? '-cost_of_gift_kit' : 'cost_of_gift_kit') : '')
            + (container.data('costCustomization') !== 0 ? (container.data('costGiftPack') !== 0 || giftkitTotal !== '0.00' ? '-cost_of_personalization' : 'cost_of_personalization') : '')
            + (container.data('costCashOnDelivery') !== 0 ? (container.data('costGiftPack') !== 0 || giftkitTotal !== '0.00' ? '-cost_of_cash_on_delivery' : 'cost_of_cash_on_delivery') : '');

        container.data('extraCostType', extrascost);
        container.data('costGiftWrapKit', parseFloat(giftkitTotal));

        if (products.length === 0) {
            return;
        }

        let actualPaymentMethod = $('.analytics.checkout.stage.confirm').data('paymentType');

        if (actualPaymentMethod === 'klarna_payments') {
            let savedKlarna = localStorage.getItem('paymentMethodKlarna');
            $('.analytics.checkout.stage.confirm').data('paymentType', savedKlarna);
        }
        let giftwrappedProducts = localStorage.getItem('giftwrappedProducts') ? localStorage.getItem('giftwrappedProducts').split('-').map((e) => {
            return this.helper.getFormatSku(e);
        }) : [];
        const purchaseData = container.data();
        container.data('shipping', parseFloat(container.data('shipping')));
        container.data('couponValue', parseFloat(container.data('couponValue')));
        container.data('value', parseFloat(container.data('value')));
        let pushObject = {
            'event': 'purchase',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'upselling_message': localStorage.getItem('upsellingMessage'),
            'ecommerce': {
                'currency': this.helperData.currency,
                ...purchaseData,
                'items': products.map((e, index) => {
                    let epid = e.item_sfcc;
                    if (giftwrappedProducts && giftwrappedProducts.indexOf(epid) > -1) {
                        e['item_gift_pack'] = 'yes';
                        giftwrappedProducts[giftwrappedProducts.indexOf(epid)] = '';
                    } else {
                        e['item_gift_pack'] = 'no';
                    }
                    if ($('.analytics-gift-kit-product').length > 0 && epid.indexOf($('.analytics-gift-kit-product').attr('data-line-item-id')) > -1) {
                        e['item_list_id'] = 'checkout';
                        e['item_list_name'] = 'gift_kit';
                    }
                    e['index'] = index;
                    return e;
                })
            }
        };

        this.log('Pushing checkout impression for final stage!', true);
        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushForStage (stage) {
        if (localStorage.getItem('from-gift-option') && localStorage.getItem('from-gift-option') === 'true') {
            localStorage.setItem('from-gift-option', false);
            return;
        }
        if (stage > 5) {
            if (localStorage.getItem('stageTwoFired') === 'false') { // case of fast checkout and redirect to confirmation page
                this.pushForStage(3);
                this.pushForStage(4);
                localStorage.setItem('stageTwoFired', true);
            }
            this.pushFinalStage(stage);
            localStorage.setItem('stepFourFired', '');
            return;
        }
        let products = this.helper.getProductList();

        if (products.length === 0) {
            return;
        }

        let storageSelectedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
        let selectedPaymentMethodId = $('.drawer:not(.hidden):not(.giftCardDrawer).active').data('method-id');
        if (selectedPaymentMethodId && !storageSelectedPaymentMethod) {
            localStorage.setItem('selectedPaymentMethod', selectedPaymentMethodId);
        }
        if (stage === 2) {
            if (document.location.href.toLowerCase().indexOf('checkout') === -1) {
                let pushObject = {
                    'event': stageEventMap[stage],
                    'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    'upselling_message': this.helper.getUpsellingMessage(),
                    'ecommerce': {
                        'currency': this.helperData.currency,
                        'value': parseFloat(this.helper.getGrandTotal()),
                        'coupon': this.helper.getAppliedCoupon(),
                        'items': products
                    }
                };
                this.push({ecommerce: null});
                this.push(pushObject);
                localStorage.setItem('stageTwoFired', false);
            }
        } else if (stage === 3) {
            let selectedShippingMethod = $('.shipping-method-type').text() || localStorage.getItem('selectedShippingMethod') || 'home_standard';
            let pushObject = {
                'event': stageEventMap[stage],
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'upselling_message': localStorage.getItem('upsellingMessage'),
                'ecommerce': {
                    'currency': this.helperData.currency,
                    'coupon': this.helper.getAppliedCoupon(),
                    'shipping_tier': this.helper.formatString(selectedShippingMethod.trim()),
                    'value': parseFloat(this.helper.getGrandTotal()),
                    'items': products
                }
            };
            this.push({ecommerce: null});
            this.push(pushObject);
            localStorage.setItem('stageTwoFired', true);
        } else if (stage === 4) {
            let giftcardActive = $('.giftCardDrawer:not(.hidden).active').data('method-id');
            let selectedPaymentMethod = $('.drawer:not(.hidden):not(.giftCardDrawer).active').data('method-id');
            if (!selectedPaymentMethod) {
                selectedPaymentMethod = localStorage.getItem('selectedPaymentMethod'); // for express checkout
            }
            let selectedPaymentMethodMapped = getPaymentMethod(selectedPaymentMethod);
            if (giftcardActive) {
                selectedPaymentMethodMapped = getPaymentMethod(giftcardActive) + '_' + selectedPaymentMethodMapped;
            }
            if (selectedPaymentMethod === 'KLARNA_PAYMENTS') {
                selectedPaymentMethodMapped = $('.drawer:not(.hidden):not(.giftCardDrawer).active').data('analytics-method');
                localStorage.setItem('paymentMethodKlarna', selectedPaymentMethodMapped);
            }
            let giftwrappedProducts = localStorage.getItem('giftwrappedProducts') ? localStorage.getItem('giftwrappedProducts').split('-').map((e) => {
                return this.helper.getFormatSku(e);
            }) : [];
            let pushObject = {
                'event': stageEventMap[stage],
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'upselling_message': localStorage.getItem('upsellingMessage'),
                'ecommerce': {
                    'currency': this.helperData.currency,
                    'coupon': this.helper.getAppliedCoupon(),
                    'payment_type': selectedPaymentMethodMapped,
                    'value': parseFloat(this.helper.getGrandTotal()),
                    'items': products.map((e, index) => {
                        let epid = e.item_sfcc;
                        if (giftwrappedProducts && giftwrappedProducts.indexOf(epid) > -1) {
                            e['item_gift_pack'] = 'yes';
                            giftwrappedProducts[giftwrappedProducts.indexOf(epid)] = '';
                        } else {
                            e['item_gift_pack'] = 'no';
                        }
                        e['index'] = index;
                        return e;
                    })
                }
            };
            if (localStorage.getItem('stageTwoFired') === 'true') {
                this.push({ecommerce: null});
                this.push(pushObject);
            }
        }
        this.log('Pushing checkout impression for step: ' + stage, true);
    }

    pushLandingInteraction () {
        let stage = getCurrentStage();
        this.pushForStage(stage);
    }

    handleNextStage (data) {
        // Leave the increment just in case another function should be used instead
        let stage = 0;
        if (data.stage === 4) {
            stage = data.stage;
        } else {
            stage = data.stage + 1;
        }
        if (stage > 1) {
            this.pushForStage(stage);
        }
    }

    applyGiftCard (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '42',
            'eventname': 'gift_card',
            'action': 'apply',
            'text': data.gcType,
            'coupon': data.gcCode
        };

        this.push(pushObject);
    }

    removeGiftCard (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '42',
            'eventname': 'gift_card',
            'action': 'remove',
            'text': data.gcType,
            'coupon': data.gcCode
        };

        this.push(pushObject);
    }

    checkGiftCard (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '51',
            'eventname': 'gift_card',
            'action': 'check',
            'text': data.gcType,
            'coupon': data.giftCardNumber
        };

        this.push(pushObject);
    }

    handleAddressInteraction (data) {
        if (!data) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '56',
            'eventname': 'shipping_address',
            'action': data.eventAction,
            'step': 'step1'
        };

        this.push(pushObject);
    }

    applyGiftWrapOrPaper (action, topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '126',
            'eventname': 'gift_options',
            'action': action,
            'area': topic
        };
        this.push(pushObject);
    }

    pushSubmitUpdateAddressInteraction (eventAction) {
        if (!eventAction) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '57',
            'eventname': 'shipping_address',
            'action': eventAction,
            'step': 'step2'
        };
        this.push(pushObject);
    }

    changeCountryInCheckout (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '93',
            'eventname': 'select_country',
            'type': data.newCountry + '-' + data.previousCountry,
            'position': 'checkout'
        };
        this.push(pushObject);
    }

    confirmChangeCountryInCheckout (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '95',
            'eventname': 'change_country',
            'action': data.action,
            'type': data.newCountry + '-' + data.previousCountry
        };
        this.push(pushObject);
    }

    prepareObservers () {
        var _self = this;
        $('body').on('checkout:afterHandleNextStage', function (e, data) {
            _self.handleNextStage(data);
        });
        $('body').on('checkout:applyGiftCard', function (e, data) {
            _self.applyGiftCard(data);
        });
        $('body').on('checkout:removeGiftCard', function (e, data) {
            _self.removeGiftCard(data);
        });
        $('body').on('check:GiftCard', function (e, data) {
            _self.checkGiftCard(data);
        });
        $('body').on('checkout:addressInteration', function (e, data) {
            localStorage.setItem('lastAction', data.eventAction);
            pushChangeStep('funnel_step2');
            _self.handleAddressInteraction(data);
        });
        $('body').on('checkout:giftInteration', function (e, data) {
            localStorage.setItem('lastAction', data.eventAction);
            pushChangeStep('funnel_step3');
            _self.handleAddressInteraction(data);
        });
        $('body').on('address:submitFromCheckout', function (e, data) {
            let lastAction = localStorage.getItem('lastAction');
            pushChangeStep('funnel_step3');
            _self.pushSubmitUpdateAddressInteraction(lastAction);
            if (lastAction) {
                localStorage.setItem('lastAction', '');
            }
        });
        $('body').on('click', '.edit-button', function (e, data) {
            pushChangeStep('funnel_step1');
            _self.handleAddressInteraction(data);
        });

        $('body').on('checkout:changeCountry', function (e, data) {
            if (data.action) {
                _self.confirmChangeCountryInCheckout(data);
            } else {
                _self.changeCountryInCheckout(data);
            }
        });
        $('body').on('click', '.button.open-gift-wrap', function (e, data) {
            _self.applyGiftWrapOrPaper('add_the_gift_wrap', 'gift_wrap');
        });
        $('body').on('click', '.js-wrap-links .open-gift-wrap', function (e, data) {
            _self.applyGiftWrapOrPaper('change_the_gift_wrap', 'gift_wrap');
        });
        $('body').on('click', '.js-wrap-links .remove-gift-wrap', function (e, data) {
            _self.applyGiftWrapOrPaper('remove_the_gift_wrap', 'gift_wrap');
        });
        $('body').on('click', '.button.open-gift-kit', function (e, data) {
            _self.applyGiftWrapOrPaper('add_the_self_gift', 'self_gift');
        });
        $('body').on('click', '.js-kit-links .open-gift-kit', function (e, data) {
            _self.applyGiftWrapOrPaper('change_the_self_gift', 'self_gift');
        });
        $('body').on('click', '.js-kit-links .remove-gift-kit', function (e, data) {
            _self.applyGiftWrapOrPaper('remove_the_self_gift', 'self_gift');
        });
    }

    // Cart Interactions
    prepareCartInteractionObservers () {
        let _self = this;

        $('body').on('analytics:paypal', function (e) {
            if (isCart() || isShipping()) {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_paypal', 'from_popup');
            } else {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_paypal', 'from_payment_page');
            }
        });
        $('body').on('analytics:applepay', function (e) {
            if (isCart() || isShipping()) {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_applepay', 'from_popup');
            } else {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_applepay', 'from_payment_page');
            }
        });
        $('body').on('click', '#checkout-button-secure-checkout', function () {
            _self.quickImpressionSender.pushBeginCheckout(_self.helper.getBeginCheckoutData(_self));
        });
        $('body').on('analytics:fakeExpressButton', function (e, data) {
            if (isCart()) {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction(data.type, 'from_cart');
            } else {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction(data.type, 'from_shipping_page');
            }
        });

        $('body').on('analytics:fastCheckoutShippingMethod', function (e, data) {
            let type = data.type;
            let name = data.name ? data.name.trim() : '';
            let user = 'guest';
            if (_self.helperData.frequentlyUser) {
                user = 'frequently_user';
            }
            _self.quickImpressionSender.pushFastShippingMethodClickInteraction(type, user, _self.helper.formatString(name));
        });
        $('body').on('analytics:paymentFastCheckout', function (e, data) {
            let method = data.method;
            let user = 'guest';
            if (_self.helperData.frequentlyUser) {
                user = 'frequently_user';
            }
            let shippingType = 'home_standard';
            if ($('.box-order-total-summary').find('.selectedStoreRecap').css('display') !== 'none') {
                shippingType = 'shop';
            } else if ($('.box-order-total-summary').find('.selectedPickupPointRecap').css('display') !== 'none') {
                shippingType = 'pickup_point';
            } else if ($('.box-order-total-summary').find('.analyticsExpressShipping').data('is-express-shipping') === 'true') {
                shippingType = 'home_express';
            }
            localStorage.setItem('selectedShippingMethod', shippingType);
            _self.quickImpressionSender.pushFastPaymentClickInteraction(method, user);
        });
        $('body').on('analytics:changeFastShippingMethod', function (e, data) {
            let method = data.method;
            let user = 'guest';
            if (_self.helperData.frequentlyUser) {
                user = 'frequently_user';
            }
            _self.quickImpressionSender.pushChangeShippingFastInteraction(method, user);
        });
        $('body').on('click', '#apple-pay-btn', function (e) {
            if ($('.page').data('action') === 'Cart-Show') {
                $('body').trigger('analytics:paymentFastCheckout', {
                    method: 'apple_pay'
                });
            }
        });
        $('body').on('gift-wrap-product-saved', function (e, data) {
            let productsname = data.productsname.split('-').map((e) => {
                return _self.helper.formatString(e);
            }).join('-');
            _self.helper.formatString(data.productsname);
            let skus = data.skus.split('-').map((e) => {
                return _self.helper.getFormatSku(e);
            }).join('-');
            _self.quickImpressionSender.pushProductsInsideGiftWrap(productsname, skus);
        });
        $('body').on('gift-kit-added', function (e, data) {
            _self.quickImpressionSender.pushGiftKit(data.quantity);
        });
        $('body').on('mouseenter', '.analytics-shipping-info-bag', function (e) {
            _self.quickImpressionSender.pushShippingMoreInfo('shipping_cost');
        });
        $('body').on('mouseenter', '.analytics-estimated-info-bag', function (e) {
            _self.quickImpressionSender.pushShippingMoreInfo('shipping_method');
        });
        $('body').on('analytics:order_review_proceed', function (e, data) {
            _self.quickImpressionSender.pushOrderReviewProceed();
        });
        $('body').on('click', '.checkout-product-summary a', function (e, data) {
            if (!$(this).closest('.checkout-product-summary').hasClass('active')) {
                let where = isCart() ? 'from_cart' : (isShipping() ? 'from_shipping_page' : (isPayment() ? 'from_payment_page' : (isGift() ? 'from_gift_page' : 'from_thankyou_page')));
                _self.quickImpressionSender.pushOrderReview('open_accordion', where);
            }
        });
        $('body').on('click', '.order-items-summary .edit-button', function (e, data) {
            let where = isCart() ? 'from_cart' : (isShipping() ? 'from_shipping_page' : 'from_payment_page');
            _self.quickImpressionSender.pushOrderReview('change', where);
        });
        $('body').on('mouseenter', '.save-credit-card .info-icon', function (e) {
            _self.quickImpressionSender.pushPaymentMoreInfo();
        });
    }
}

const obj = new CheckoutFunnel();
module.exports = obj;
